import { RenderedMarkdown } from '../rendered-markdown.tsx'

export type OutcomeReasonDetailsProps = {
  reason?: string
  details?: string
  fallback: React.ReactNode
}

/**
 * Renders a blocked/excluded outcome's own `reason`/`details` as markdown. These outcomes have no
 * article/report (the endpoints 404), so the drawers show this in place of the article. When neither
 * field is populated, `fallback` is rendered — each drawer supplies its own domain-appropriate
 * placeholder.
 */
export const OutcomeReasonDetails: React.FC<OutcomeReasonDetailsProps> = ({ reason, details, fallback }) => {
  if (!reason && !details) {
    return <>{fallback}</>
  }

  return (
    <>
      {reason && <RenderedMarkdown markdown={reason} />}
      {details && <RenderedMarkdown markdown={details} />}
    </>
  )
}
